"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translate = translate;
function translate(text, dict) {
  if (!dict?.length) {
    return text;
  }
  return dict.find(({
    dictKey
  }) => String(dictKey) === String(text))?.dictValue ?? text;
}